import clsx from 'clsx'
import CalendarIcon from '@ancon/wildcat-ui/shared/icons/calendar-event-outline.svg'
import PaperBagIcon from '@ancon/wildcat-ui/shared/icons/paper-bag-outline.svg'
import TrashIcon from '@ancon/wildcat-ui/shared/icons/trash-bin-outline.svg'

import { CapacityConflictOptionType } from '../../types'

import styles from './CapacityConflictVisualIcon.module.scss'

export type CapacityConflictVisualVariant = CapacityConflictOptionType

function getVariantIcon(variant: CapacityConflictVisualVariant) {
  switch (variant) {
    case CapacityConflictOptionType.AdjustOrder:
      return PaperBagIcon

    case CapacityConflictOptionType.DeleteOrder:
      return TrashIcon

    case CapacityConflictOptionType.ChangePickupTime:
    default:
      return CalendarIcon
  }
}

type CapacityConflictVisualIconProps = {
  variant: CapacityConflictVisualVariant
}

export default function CapacityConflictVisualIcon({
  variant,
}: CapacityConflictVisualIconProps) {
  const Icon = getVariantIcon(variant)

  return (
    <span
      className={clsx(styles.iconCircle, {
        [styles.delete]: variant === CapacityConflictOptionType.DeleteOrder,
      })}
    >
      <Icon className={styles.icon} />
    </span>
  )
}
